import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { Card, Accordion } from 'react-bootstrap';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker, } from '@material-ui/pickers';
import LaddaButton, { EXPAND_RIGHT } from 'react-ladda';
import moment from 'moment-timezone';
import SimpleReactValidator from 'simple-react-validator';
import { userActions } from '../../../../../common/redux/actions';

class Experiences extends Component {

    constructor(props) {
        super(props);
        this.state = {
            formField: {
                title: "",
                industry_name: "",
                from: null,
                to: null,
                description: "",
                is_present: 0,
            },
            toggleExperience: false,
            item: null
        };
        this.resetState = this.state.formField;
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            className: 'valid-feedback d-block text-danger',
        });
    }

    componentDidMount() {
        const { dispatch, experiences } = this.props;
        experiences && experiences.experiences && experiences.experiences.length === 0 && dispatch(userActions.experience("GET"));
    }

    handleChange = (e) => {
        const { name, value, checked, type } = e.target;
        let formField = {...this.state.formField};
        formField[name] = (type === 'checkbox') ? (checked === true) ? 1 : '' : value;
        this.setState({formField});
    };

    handleFromDate = (dated) => {
        let formField = { ...this.state.formField };
        formField['from'] = moment(dated).format("X");
        this.setState({ formField });
    };

    handleToDate = (dated) => {
        let formField = { ...this.state.formField };
        formField['to'] = moment(dated).format("X");
        this.setState({ formField });
    };

    resetForm = () => {
        this.setState({formField: this.resetState, item: null, toggleExperience: false});
    }

    addNew = () => {
        this.setState({ formField: this.resetState, item: null, toggleExperience: true})
    }

    onDelete = (id) => {
        const { dispatch } = this.props;
        dispatch(userActions.experience("DELETE", null, {item_id: id}));
    }

    onEdit = (item) => {
        let formField = { ...this.state.formField };
        formField['title'] = item.title;
        formField['industry_name'] = item.industry_name;
        formField['from'] = item.from;
        formField['to'] = item.to;
        formField['description'] = item.description;
        formField['is_present'] = item.is_present;
        this.setState({formField, item, toggleExperience: true});
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { formField, item } = this.state;
        if(this.validator.allValid()) {
            const { dispatch } = this.props;
            const item_id = (item !== null) ? {item_id: item.id} : null;
            dispatch(userActions.experience("POST", {userExperience: formField}, item_id));
            let vm = this;
            setTimeout(function(){
                vm.resetForm();
            }, 1200);
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    render() {
        this.validator.purgeFields();
        const { formField, toggleExperience, item } = this.state;
        const { experiences } = this.props;
        const experienceItems = (experiences && experiences.experiences) ? experiences.experiences : null;
        //console.log('experiences.loading', experienceItems)
        return (
            <div className="experience">
                <Card.Title className="d-flex justify-content-between">Experience
                    <button onClick={this.addNew} className="btn btn-outline-primary btn-sm">Add New</button>
                </Card.Title>

                <Accordion.Collapse in={toggleExperience} className="w-100">
                    <section className="login-page p-lg-4">
                        <div className="experience-form login-box">
                         <form name="experience" onSubmit={this.handleSubmit} encType="multipart/form-data" noValidate>
                            <div className="row">
                                <div className="col-md-6 col-12">
                                    <div className="form-group">
                                        <label>Title / Designation</label>
                                        <input className="form-control" name="title" value={formField.title} onChange={this.handleChange} placeholder="Enter Title / Designation" />
                                        {this.validator.message('title', formField.title, 'required')}
                                    </div>
                                </div>
                                <div className="col-md-6 col-12">
                                    <div className="form-group">
                                        <label>Company Name</label>
                                        <input className="form-control" name="industry_name" value={formField.industry_name} onChange={this.handleChange} placeholder="Enter Company Name" />
                                        {this.validator.message('industry_name', formField.industry_name, 'required')}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 col-12">
                                    <div className="form-group">
                                        <label>Start Month-Year</label>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                id="date-picker-from3-dialog"
                                                placeholder="Start Date"
                                                value={(formField.from) ? (new Date(formField.from * 1000)) : null}
                                                format="MM/dd/yyyy"
                                                onChange={this.handleFromDate}
                                                maxDate={new Date()}
                                                className={'input-box w-100'}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                        {this.validator.message('from', formField.from, 'required')}
                                    </div>
                                </div>
                                <div className="col-md-6 col-12">
                                    <div className="form-group">
                                        <label>End Month-Year</label>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                id="date-picker-to3-dialog"
                                                placeholder="End Date"
                                                value={(formField.to) ? (new Date(formField.to * 1000)) : null}
                                                format="MM/dd/yyyy"
                                                onChange={this.handleToDate}
                                                maxDate={new Date()}
                                                minDate={new Date(formField.from * 1000)}
                                                disabled={(formField.is_present === 1) ? true : false}
                                                className={'input-box w-100'}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                        <small className="form-text text-muted mt-3">
                                            <div className="custom-control custom-checkbox">
                                                <input type="checkbox" className="custom-control-input" name="is_present" value={formField.is_present} onChange={this.handleChange} id="customCheckw1" checked={formField.is_present === 1 ? true : false} onChange={this.handleChange} />
                                                <label className="custom-control-label" htmlFor="customCheckw1">Present</label>
                                            </div>
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-group">
                                        <label>Description (Optional)</label>
                                        <textarea className="form-control" name="description" value={formField.description} onChange={this.handleChange} placeholder="Describe your Experience"></textarea>
                                    </div>
                                    <div className="form-group">
                                        <LaddaButton className={`btn btn-submit ${(item === null) ? 'btn-primary mr-3' : 'btn-success'}`} loading={experiences.loading} data-style={EXPAND_RIGHT}>{(item === null) ? 'Add' : 'Update'} Experience</LaddaButton>
                                        <button className="btn btn-info btn-submit ml-md-4 py-2 px-5 text-uppercase" onClick={this.resetForm}>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                        </div>
                    </section>
                </Accordion.Collapse>

                <ul className="list-group">

                    {/* {(experienceItems === null) ? 'Loading' : 'Loaded'} */}

                    {experienceItems && experienceItems.map(item =>
                        (<li key={`education-${item.id}`} className="list-group-item">
                            <div className="row">
                                <div className="col-lg-10 col-md-12">
                                    <h6 className="col pl-0">{item.title} </h6>
                                    <p className="text">({`${moment(item.from * 1000).format('MM/YYYY')} to ${item.is_present === 1 ? 'Present' : moment(item.to * 1000).format('MM/YYYY')}`})</p>
                                    <p className="text">{item.description}</p> 
                                </div>
                                <div className="col-lg-2 col-md-12">    
                                    <div className="button">
                                        <button className="btn bg-primary rounded-circle float-right px-2 py-1 mx-1" onClick={() => this.onDelete(item.id)}><i
                                            className="far fa-trash-alt text-white"></i></button>
                                        <button className="btn bg-primary rounded-circle float-right px-2 py-1 mx-1" onClick={() => this.onEdit(item)}><i className="fas fa-pencil-alt text-white"></i></button>

                                    </div>
                                </div>
                            </div>
                        </li>)
                    )}

                    {((experienceItems && experienceItems.length === 0) && (experiences.loading === false)) &&
                        <div className="pl-4">Experience not found</div>
                    }

                </ul>

            </div>
        );
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const experiencesSelector = createSelector(
    state => state.experiences,
    experiences => experiences
);

const mapStateToProps = createSelector(
    processSelector,
    authenticationSelector,
    experiencesSelector,
    (process, authentication, experiences) => ({
        process, authentication, experiences
    })
);

export default connect(mapStateToProps)(Experiences);